import React from 'react';
import { I18n } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';
import CustomReveal from '../../common/reveal/CustomReveal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import reconnect from '../../../styles/default/icons/reconnect.svg';

class NotCanUploadFilesReveal extends React.Component {
  closeModal = () => {
    const { classroomActions } = this.props;
    classroomActions.setNotCanUploadFilesModalIsOpen(false);
  };
  render() {
    const { active } = this.props;
    return (
      <CustomReveal id="notUpload" active={active} close={this.closeModal}>
        <div className="notUpload-reveal">
          <div className="header">
            <img alt="" src={reconnect} />
          </div>
          <div className="archive-classroom">
            <div className="text">{I18n.t('notCanUploadFiles.description')}</div>
          </div>
          <div className="footer">
            <div className="footer-content">
              <button type="button" className="button secondary" onClick={this.closeModal}>
                {I18n.t('common.close')}
              </button>
            </div>
          </div>
        </div>
      </CustomReveal>
    );
  }
}

NotCanUploadFilesReveal.propTypes = {
  active: PropTypes.bool,
  notCanUploadFilesModalIsOpen: PropTypes.bool,
  classroomActions: PropTypes.any
};

function mapStateToProps(state) {
  return {
    active: state.classrooms.notCanUploadFilesModalIsOpen,
    colors: state.theme.colors,
    icons: state.theme,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotCanUploadFilesReveal);
